import { ButtonType } from "@/types/library/Buttons";
import type { IButton } from "@/types/library/Buttons";
import { cn } from "@/utils/css";
import Icon from "../Icon";

const Button = ({
  text = "",
  icon,
  buttonType = ButtonType.Primary,
  padding = "px-4 py-2",
  id,
  fontSize = "text-base",
  fontWeight = "font-bold",
  rounding = "rounded-xl",
  margin = "my-2",
  width = "w-auto",
  border = "border border-transparent",
  outline = "focus:outline-none",
  extraClasses,
  onClick,
  disabled = false,
  isSubmitButton = false,
  textClasses,
  iconClasses = "mr-2",
  rightIcon,
  rightIconClasses,
}: IButton) => {
  const colourClassName = () => {
    let className = "";

    if (typeof buttonType === "string") {
      className = buttonType;
      return className;
    }

    switch (buttonType) {
      case ButtonType.Primary:
        className = "bg-dines-green text-dines-purple-darkest";
        break;
      case ButtonType.Secondary:
        className =
          "bg-dines-purple text-white dark:bg-dines-dark-mode-green dark:text-dines-dark-mode-purple";
        break;
      case ButtonType.Danger:
        className = "bg-red-500 text-white";
        break;
      default:
        className = buttonType;
        break;
    }

    return className;
  };

  return (
    <button
      id={id}
      data-testid={id}
      data-active={!disabled}
      type={isSubmitButton ? "submit" : "button"}
      disabled={disabled}
      onClick={onClick && onClick}
      className={cn(
        width,
        margin,
        fontSize,
        fontWeight,
        colourClassName(),
        padding,
        border,
        rounding,
        outline,
        extraClasses || "",
        disabled ? "cursor-not-allowed opacity-30" : "",
      )}
    >
      {icon && (
        <span className={iconClasses}>
          <Icon icon={icon} id={`${id}-icon`} />
        </span>
      )}
      <span
        className={`${textClasses}`}
        id={`${id}-text`}
        data-testid={`${id}-text`}
      >
        {text}
      </span>

      {rightIcon && (
        <span>
          <Icon
            icon={rightIcon}
            className={rightIconClasses}
            id={`${id}-right-icon`}
          />
        </span>
      )}
    </button>
  );
};

export default Button;
